export const tourMessages = {
  adminDash: {
    title: "Select frequency of posts.",
    target:".joyride1",
    content:"Select frequency of posts."
  },
  default:{
    title: "Our Fail Test",
    content: "This step should fail",
    target: ".demo__rumba",
    placement: "top",
  },
  adminPendingTables:{
    title: "View pending posts from Instructors.",
    target:".joyride2",
    content:"View pending posts from Instructors." 
  },
  adminContentsTables:{
    title: "View all posts from Instructors.",
    target:".joyride3",
    content:"View all posts from Instructors." 
  },
  adminCategoryForm:{
    title: "Click here to create a category",
    target:".joyride4",
    content:"(You must create a category before creating an interest)." 
  },
  adminCategoryTable:{
    title: "Click here to view categories created.",
    target:".joyride5",
    content:"(Click the edit button to edit category)." 
  },
  adminInterestForm:{
    title: "Click here to create interest.",
    target:".joyride6",
    content:"(You must create a category before creating an interest)." 
  },
  adminInterestTable:{
    title: "Click here to view interests created.",
    target:".joyride7",
    content:"(Click the edit button to edit interests)." 
  },
  adminActivityForm:{
    title: "Click here to create activity.",
    target:".pp1",
    content:null
  },
  adminActivityTable:{
    title: "Click here to view activities created.",
    target:".pp2",
    content:"(Click the edit button to edit activity)." 
  },
  adminEventForm:{
    title: "Click here to create event.",
    target:".pp3",
    content:null
  },
  adminEventTable:{
    title: "Click here to view events created.",
    target:".pp4",
    content:"(Click the edit button to edit event)." 
  },
  adminInstructorForm:{
    title: "Click here to create an Instructor.",
    target:".joyride8",
    content:null
  },
  adminInstructorTable:{
    title: "Click here to view instructors created.",
    target:".joyride9",
    content:"(Click the edit button to edit Instructors)"
  },
  instructorPendingTable:{
    title: "Click here to view post status.",
    target:".joyride10",
    content:"(Click the view button for more details)"
  },
  instructorDraftTable:{
    title: "Click here to view drafts.",
    target:".joyride11",
    content:"(You can edit, delete and publish your drafts)"
  },
  instructorInterests:{
    title: "Select the interest drop-down to select your interest.",
    target:".joyride12",
    content:null
  },
  instructorTitle:{
    title: "Type your post title.",
    target:".joyride13",
    content:null
  },
  instructorImage:{
    title: "Choose your post header image ",
    target:".joyride14",
    content:"(Note this is optional)"
  },
  instructorPost:{
    title: "Type the main content of your post. ",
    target:".joyride15",
    content:null
  },
  instructorDraft:{
    title: "Click on this button to save your post. ",
    target:".joyride16",
    content:null
  },
  instructorPublish:{
    title: "Click on this button to Publish your post. ",
    target:".joyride17",
    content:"(This will be pending approval by the administrator)"
  },
}
